import { documentTypeService } from '@/services/document-type-service'
import { normalize } from 'normalizr'
import { schemas } from '@/store/schemas'
import { GET_DOCUMENT_TYPES, SET_DOCUMENT_TYPES } from '@/store/mutation-types'
import _ from 'lodash'

export const namespaced = false
export const state = {
  documentTypes: {},
  fetching: false
}

export const mutations = {
  [SET_DOCUMENT_TYPES](state, documentTypes) {
    const normalized = normalize(documentTypes, schemas.documentTypeList)
    state.documentTypes = normalized.entities.documentTypes
  },
  SET_DOCUMENT_TYPES_FETCHING(state, fetching) {
    state.fetching = fetching
  }
}

export const actions = {
  async [GET_DOCUMENT_TYPES]({ commit }) {
    commit('SET_DOCUMENT_TYPES_FETCHING', true)
    let documentTypes
    try {
      const response = await documentTypeService.list()
      documentTypes = [...response.data, { id: null, fullName: 'Other' }]
      commit(SET_DOCUMENT_TYPES, documentTypes)
    } finally {
      commit('SET_DOCUMENT_TYPES_FETCHING', false)
    }
    return documentTypes.data || []
  }
}

export const getters = {
  getDocumentTypeSelectOptions() {
    return _.map(state.documentTypes, item => {
      return { id: item.id, fullName: item.fullName }
    })
  }
}
